import * as angular from "angular";
import {IController} from "angular";
import {PdfFormTemplateModel} from "../../models/pdf-form-template.model";
import {PdfFormTemplatesDialogService} from "../../services/pdf-form-templates-dialog.service";
import {PdfFormTemplatesService} from "../../services/pdf-form-templates.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class DocumentsManagementViewComponent implements IController {

  pdfFormTemplates: PdfFormTemplateModel[];

  public queryString: string;

  constructor(private pdfFormTemplatesDialogService: PdfFormTemplatesDialogService,
              private confirmDialogService: ConfirmDialogService,
              private pdfFormTemplatesService: PdfFormTemplatesService) {
  }

  $onInit() {

  }

  submitQuery(queryString) {
    this.queryString = queryString;
  }

  onAddDocument() {
    this.pdfFormTemplatesDialogService.onAddDocument()
      .then((pdfFormTemplateToCreate: PdfFormTemplateModel) => {
        this._createTemplate(pdfFormTemplateToCreate)
      })
  }

  onEditDocument(pdfFormTemplate: PdfFormTemplateModel) {
    this.pdfFormTemplatesDialogService.onEditDocument(pdfFormTemplate)
      .then((pdfFormTemplateToCreate: PdfFormTemplateModel) => {
        this._updateTemplate(pdfFormTemplateToCreate)
      })
  }

  onDeleteDocument(pdfFormTemplate: PdfFormTemplateModel, $event) {
    const text = 'Are you sure you want to delete this document?';
    this.confirmDialogService.confirm('Delete Document', text, $event)
      .then(() => {
        this._deleteTemplate(pdfFormTemplate);
      })
  }

  private _createTemplate(pdfFormTemplate: PdfFormTemplateModel) {
    this.pdfFormTemplatesService.createOne(pdfFormTemplate)
      .then(() => {
        this.pdfFormTemplates = this.pdfFormTemplates.concat(pdfFormTemplate);
      })
  }

  private _updateTemplate(pdfFormTemplate: PdfFormTemplateModel) {
    this.pdfFormTemplatesService.updateOne(pdfFormTemplate.id, pdfFormTemplate)
      .then((updatedPdfFormTemplate: PdfFormTemplateModel) => {
        const index = this.pdfFormTemplates.findIndex((p) => {
          return p.id === pdfFormTemplate.id;
        })
        if (index > -1) {
          const pdfFormTemplatesCopy = angular.copy(this.pdfFormTemplates);
          pdfFormTemplatesCopy.splice(index, 1, updatedPdfFormTemplate);

          this.pdfFormTemplates = pdfFormTemplatesCopy;
        }
      })
  }

  private _deleteTemplate(pdfFormTemplate: PdfFormTemplateModel) {
    this.pdfFormTemplatesService.deleteOne(pdfFormTemplate.id)
      .then((pdfFormTemplateRemoved: PdfFormTemplateModel) => {
        this.pdfFormTemplates = this.pdfFormTemplates.filter((t) => {
          return t.id !== pdfFormTemplateRemoved.id;
        });
      })
  }

}

angular
  .module('bringoz.admin.document-management')
  .component('documentsManagementView', {
    bindings: {
      pdfFormTemplates: '<'
    },
    template: require('./documents-management-view.html').default,
    controller: DocumentsManagementViewComponent
  });
